export default class {
    constructor (lodash, PrivilegeService, ModalService, OCCURRENCE_STATUS_ENUM, COURSE_PROGRESS_STATUS_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM) {
        this.lodash = lodash;
        this.PrivilegeService = PrivilegeService;
        this.ModalService = ModalService;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
    }

    isPublished (occurrence) {
        return occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED;
    }

    isCancelled (occurrence) {
        return occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.CANCELLED;
    }

    manageTrainingTime (occurrence, canManageOccurrences, rooms, trainers, trainingCompanies, training, time) {
        return this.ModalService.open({
            template: `
                <modals-courses-occurrence-manage-training-time
                    uib-modal-instance="vm.$uibModalInstance"
                    occurrence="vm.occurrence"
                    can-manage-occurrences="vm.canManageOccurrences"
                    rooms="vm.rooms"
                    trainers="vm.trainers"
                    training="vm.training"
                    time="vm.time"
                    training-companies="vm.trainingCompanies"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.occurrence = occurrence;
                this.canManageOccurrences = canManageOccurrences;
                this.rooms = rooms;
                this.trainers = trainers;
                this.trainingCompanies = trainingCompanies;
                this.training = training;
                this.time = time;
            }
        });
    }

    assignParticipants (occurrence, training, index, participants, isRoomOverbooked, room) {
        return this.ModalService.open({
            template: `
                <modals-courses-occurrence-assign-participants
                    on-save="vm.save()"
                    on-close="vm.$uibModalInstance.dismiss()"
                    is-room-overbooked="vm.isRoomOverbooked"
                    occurrence="vm.occurrence"
                    room="vm.room"
                    training="vm.training"
                    index="vm.index"
                    participants="vm.participants"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.occurrence = occurrence;
                this.training = training;
                this.index = index;
                this.participants = participants;
                this.isRoomOverbooked = isRoomOverbooked;
                this.room = room;
                this.save = this.$uibModalInstance.close;
            }
        });
    }

    signParticipation (user, trainingTime) {
        return this.ModalService.open({
            template: `
                <modals-courses-occurrence-sign-participation
                    on-save="vm.save()"
                    on-close="vm.$uibModalInstance.dismiss()"
                    user="vm.user"
                    training-time="vm.trainingTime"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.user = user;
                this.trainingTime = trainingTime;
                this.save = this.$uibModalInstance.close;
            }
        });
    }

    getSignatureThumbnailUrl (trainingTimeId, filename) {
        return `${SEED_CORE.ENV.API_URL}/signatures/${trainingTimeId}/thumbnails/small/${filename}`;
    }

    isReadonlyOccurrence (occurrence) {
        return this.isCancelled(occurrence)
            || this.isPublished(occurrence)
            || !this.PrivilegeService.canManageOccurrences()
        ;
    }

    canManageScheduleTab (occurrence) {
        return !this.isCancelled(occurrence) && this.PrivilegeService.canManageOccurrences();
    }

    copyFrom (copyFromOccurrence, message) {
        const showCopyAllOption = this.getFinishedParticipants(copyFromOccurrence).length;
        return this.ModalService.open({
            template: `
                <modals-courses-occurrence-copy-from
                    on-save="vm.save()"
                    on-close="vm.$uibModalInstance.dismiss()"
                    copy-from-occurrence="vm.copyFromOccurrence"
                    show-copy-all-option="vm.showCopyAllOption"
                    message="vm.message"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.copyFromOccurrence = copyFromOccurrence;
                this.showCopyAllOption = showCopyAllOption;
                this.message = message;
                this.save = this.$uibModalInstance.close;
            }
        });
    }

    getFinishedParticipants (occurrence) {
        const statuses = [
            this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.PASSED,
            this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_PASSED
        ];

        return occurrence.courseOccurrenceParticipants
            ? occurrence.courseOccurrenceParticipants.filter((participant) => this.lodash.includes(statuses, participant.courseProgressStatus))
            : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/services/occurrence/index.js